import React, { useEffect,useState } from 'react'

function CardSucursal(props) {
    const { info,tipo,turno } = props;
    const [personalAsignado, setPersonalAsignado] = useState([]);
    const [personalRequerido, setPersonalRequerido] = useState([]);
    const [numHombres,setNumHombres] = useState(0);
    const [numMujeres,setNumMujeres] = useState(0);
    const [numActivos,setNumActivos] = useState(0);
    const [cargado,setCargado] = useState(false);
    const [sumRequerido,setSumRequerido] = useState(0);
    function sumPersonalRequerido(lista) {
        var sumatoria = 0;
        for (var i = 0; i < lista.length; i++) {
            if(turno=='*'){
                sumatoria += lista[i].CANTIDAD
            }else{
                if(turno===lista[i].TURNO){
                    sumatoria += lista[i].CANTIDAD
                }
            }
        }
        setSumRequerido(sumatoria);
    }
    function filtrosRequeridos(lista){
        var contH=0,contM=0,contAc=0;
        for (var i =0 ; i<lista.length;i++){
            if(lista[i].CARNET_SEXO==='F'){
                contM+=1;
            }else if(lista[i].CARNET_SEXO==='M'){
                contH+=1;
            }else if(lista[i].ASISTENCIA.length>0){
                contAc+=1;
            }
        }
        setNumHombres(contH);
        setNumMujeres(contM);
        setNumActivos(contAc);
    }
    useEffect(()=>{
        if(info){
            setPersonalAsignado(info.ASIGNADO);
            setPersonalRequerido(info.REQUERIDO);
            filtrosRequeridos(info.ASIGNADO);
            sumPersonalRequerido(info.REQUERIDO);
            setCargado(true);
        }
    },[])
    return (
        <>
            {cargado&&
            <div className="card-body m-0 p-0">
                <div className='container-fluid bg-dark bg-gradient m-0 p-0'>
                    <div className={tipo==='C'?'row row-cols-3 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-5 g-0':'row row-cols-3 row-cols-sm-5 row-cols-md-5 row-cols-lg-5 row-cols-xl-5 row-cols-xxl-5 g-0'}>
                        <div className='col text-center border m-0 p-0'>
                            <div className='text-light fw-bold fs-6 text-center m-0 p-0'>
                                Asignado
                            </div>
                            <div className='text-light fs-1 fw-bold text-center m-0 p-0'>
                                {personalAsignado.length}
                            </div>
                        </div>
                        <div className='col text-center border m-0 p-0'>
                            <div className='text-primary fw-bold text-center m-0 p-0'>
                                Hombres
                            </div>
                            <div className='text-primary fs-1 fw-bold text-center m-0 p-0'>
                                {numHombres}
                            </div>
                        </div>
                        <div className='col  text-center border m-0 p-0'>
                            <div className='colorPing fw-bold text-center m-0 p-0'>
                                Mujeres
                            </div>
                            <div className='colorPing fs-1 fw-bold text-center m-0 p-0'>
                                {numMujeres}
                            </div>
                        </div>
                        <div className='col  text-center border m-0 p-0'>
                            <div className='text-light fw-bold fs-6 text-center m-0 p-0'>
                                Requerido
                            </div>
                            <div className='text-light fs-1 fw-bold text-center m-0 p-0'>
                                {sumRequerido}
                            </div>
                        </div>
                        <div className='col  text-center border m-0 p-0'>
                            <div className='colorVerde fw-bold text-center m-0 p-0'>
                                Activos
                            </div>
                            {turno!='*'&&<div className='colorVerde fs-1 fw-bold text-center m-0 p-0'>
                                {info.ASIGNADO.filter((item) => item.ASISTENCIA.length > 0&& item.EMPRESA_TURNO==turno).length}
                            </div>}
                            {turno=='*'&&<div className='colorVerde fs-1 fw-bold text-center m-0 p-0'>
                                {info.ASIGNADO.filter((item) => item.ASISTENCIA.length > 0).length}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default CardSucursal
